<template>
  <div class="mb-4">
    <v-row class="fill-height ma-0 pa-0 elevation-5">
      <v-col class="ma-0 pa-0">
        <v-sheet height="64">
          <v-toolbar flat color="light-blue darken-4" dark>
            <v-btn outlined class="mr-4" @click="setToday">
              Today
            </v-btn>
            <v-btn fab text small @click="prev">
              <v-icon small>
                fa-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small @click="next">
              <v-icon small>
                fa-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @click:day="addDayEvent"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-btn icon>
                  <v-icon>fa-edit</v-icon>
                </v-btn>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>fa-heart</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon>fa-ellipsis-h</v-icon>
                </v-btn>
              </v-toolbar>
              <div v-if="selectedEvent.description">
                <v-card-title>
                  Description
                </v-card-title>
                <v-card-subtitle>
                  <span v-html="selectedEvent.description"></span>
                </v-card-subtitle>
              </div>
              <v-divider></v-divider>
              <!-- <v-card-subtitle >
                Description
                <v-divider></v-divider>
                <v-card-text>
                  <span v-html="selectedEvent.description"></span>
                </v-card-text>
              </v-card-subtitle> -->
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
        <v-toolbar flat color="light-blue darken-4" dark>
          <v-btn outlined @click="showInfo" class="mr-2">Add event</v-btn>
          <v-btn outlined v-if="!authorized" @click="handleAuthClick">
            Sign In
          </v-btn>
          <v-btn outlined v-if="authorized" @click="handleSignoutClick">
            Sign Out
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <!--Add new event dialog-->
    <v-dialog v-model="calendarEventDialog" max-width="900">
      <v-card>
        <v-card-title class="text-h5 light-blue darken-4">
          <span style="color: white;">Add new event</span>
        </v-card-title>
        <!--Add new event stepper-->
        <v-stepper v-model="stepperElement">
          <v-stepper-header>
            <v-stepper-step :complete="stepperElement > 1" step="1">
              Confirm rules
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepperElement > 2" step="2">
              Select event type
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3">
              Fill form
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12 d-flex align-center justify-center"
                flat
                height="200px"
              >
                <v-alert
                  color="light-blue darken-4"
                  dark
                  icon="fa-question"
                  border="left"
                  prominent
                >
                  Do you agree to add a new event to your google calendar
                  account that you define in the future?
                </v-alert>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-12" flat min-height="200px">
                <v-card-title class="justify-center">
                  <v-alert
                    color="light-blue darken-4"
                    dark
                    class="hidden-xs-only"
                    icon="fa-question"
                    border="left"
                    prominent
                  >
                    In the section below you should see the type of event you
                    are adding, on which the form for filling out the event data
                    will depend
                  </v-alert>
                </v-card-title>
                <v-card-subtitle>
                  <v-flex xs12 sm7 class="mx-auto">
                    <CalendarEventsDropDown
                      @event-changed="calendarEvent = $event"
                    />
                  </v-flex>
                </v-card-subtitle>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <CalendarForm
                :eventType="calendarEvent"
                :eventDateInfo="newEventData"
                @close-form="closeForm"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <v-divider></v-divider>

        <v-card-actions v-if="stepperElement !== 3">
          <v-spacer></v-spacer>
          <v-btn color="light-blue darken-4" dark @click="stepperAction">
            Continue
          </v-btn>
          <v-btn color="light-blue darken-4" text @click="closeForm">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { apiKeys } from "@/constants/global";
import CalendarEventsDropDown from "@/components/shared/CalendarEventDrpDwn.vue";
import CalendarForm from "./CalendarForm.vue";
const SCOPES = "https://www.googleapis.com/auth/calendar";
const DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
];

export default {
  components: { CalendarEventsDropDown, CalendarForm },
  data: () => ({
    newEventData: false,
    calendarEvent: "",
    stepperElement: 1,
    calendarEventDialog: false,
    items: undefined,
    authorized: false,
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days"
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1"
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party"
    ]
  }),
  computed: {
    nextStepperStep() {
      switch (this.stepperElement) {
        case 1:
          return 2;
        case 2:
          return 3;
        default:
          return 1;
      }
    }
  },
  methods: {
    addDayEvent(date) {
      this.newEventData = date;
      this.calendarEventDialog = true;
    },
    closeForm() {
      this.stepperElement = 1;
      this.calendarEvent = "";
      this.newEventData = false;
      this.calendarEventDialog = false;
    },
    stepperAction() {
      if (this.stepperElement === 3) {
        console.log(this.newEventData);
        return;
      }

      this.stepperElement = this.nextStepperStep;
    },
    showInfo() {
      this.calendarEventDialog = true;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    /**
     *  Initializes the API client library and sets up sign-in state
     *  listeners.
     */
    /**
     *  On load, called to load the auth2 library and API client library.
     */
    handleClientLoad() {
      window.gapi.load("client:auth2", this.initClient);
    },

    /**
     *  Initializes the API client library and sets up sign-in state
     *  listeners.
     */
    initClient() {
      window.gapi.client
        .init({
          apiKey: apiKeys.googleApiKey,
          clientId: apiKeys.googleClientId,
          discoveryDocs: DISCOVERY_DOCS,
          scope: SCOPES
        })
        .then(() => {
          // Listen for sign-in state changes.
          window.gapi.auth2
            .getAuthInstance()
            .isSignedIn.listen(this.updateSigninStatus);

          // Handle the initial sing-in state.
          this.updateSigninStatus(
            window.gapi.auth2.getAuthInstance().isSignedIn.get()
          );
        })
        .catch(error => {
          console.error(`Error in initClient func. Full info => ${error}`);
        });
    },
    /**
     *  Called when the signed in status changes, to update the UI
     *  appropriately. After a sign-in, the API is called.
     */
    updateSigninStatus(isSignedIn) {
      if (isSignedIn) {
        this.authorized = true;
        this.listUpcomingEvents();
      } else {
        this.authorized = false;
      }
    },

    /**
     *  Sign in the user upon button click.
     */
    handleAuthClick() {
      window.gapi.auth2.getAuthInstance().signIn();
    },

    /**
     *  Sign out the user upon button click.
     */
    handleSignoutClick() {
      window.gapi.auth2.getAuthInstance().signOut();
      this.events = [];
    },

    /**
     * Print the summary and start datetime/date of the next ten events in
     * the authorized user's calendar. If no events are found an
     * appropriate message is printed.
     */
    listUpcomingEvents() {
      window.gapi.client.calendar.events
        .list({
          calendarId: "primary",
          timeMin: new Date().toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: "startTime"
        })
        .then(response => {
          const calendarData = response.result.items;
          this.events = calendarData.map(el => ({
            name: el.summary,
            description: el.description,
            start: el.start.date,
            end: el.end.date,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: "-"
          }));
          console.log(calendarData);
        })
        .catch(error => {
          console.error(
            `Error in listUpcomingEvents func. Full info => ${error}`
          );
        });
    }
  },
  /**
   *  On load, called to load the auth2 library and API client library.
   */
  mounted() {
    this.handleClientLoad();
  }
};
</script>
